import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const activoImporterSelectors = importerSelectors(
  'activo.importer',
);

export default activoImporterSelectors;
